import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bevvi-homebanner',
  templateUrl: './homebanner.component.html',
  styleUrls: ['./homebanner.component.scss']
})
export class HomebannerComponent implements OnInit {

  public imageUrl = "/assets/images/banner-img/home-banner.png"
  // @Input() image: string;
  @Input() heading: string;
  @Input() paragraph: string;

  constructor() { }

  ngOnInit() {



  }

}
